/**
 * Тарифные лимиты.
 * В будущем: создание второй и последующих свадеб — платно (Premium).
 * Точка проверки при создании свадьбы; сейчас лимита нет.
 */
export function canCreateWedding(_currentCount: number): boolean {
  return true;
}
